/* eslint-disable @typescript-eslint/member-ordering */
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IJobOrderDetail } from 'app/models';
import { JobOrderService } from 'app/services/job/job.order.service';

import { map } from 'rxjs/operators';

export interface JobOrderDetailData {
  jobOrderId: number;
}

@Component({
  selector: 'app-job-order-detail-dialog-component',
  templateUrl: './job-order-detail-dialog.component.html',
  styleUrls: ['./job-order-detail-dialog.component.scss'],
})
export class JobOrderDetailDialogComponent implements OnInit {
  jobOrderDetail?: IJobOrderDetail;
  chartType = 'Timeline';
  public chartData?: any = undefined;

  private jobOrderId?: number;

  @ViewChild('chart') chart: ElementRef<HTMLCanvasElement> | undefined;

  constructor(
    public dialogRef: MatDialogRef<JobOrderDetailDialogComponent>,
    private jobOrderService: JobOrderService,
    @Inject(MAT_DIALOG_DATA) public data: JobOrderDetailData
  ) {
    this.jobOrderId = data.jobOrderId;
  }

  ngOnInit(): void {
    if (this.jobOrderId) {
      this.jobOrderService
        .getJobOrderOrderDetail(this.jobOrderId)
        .pipe(
          map((jobOrderDetail) => {
            this.jobOrderDetail = jobOrderDetail;
            this.inflateChartData(jobOrderDetail.data);
          })
        )
        .subscribe();
    }
  }

  private inflateChartData(data: any) {
    this.chartData = {
      chartType: 'Timeline',
      dataTable: [['Name', 'Start Time', 'End Time'], ...data],
    };
  }
}
